/* eslint-disable */
import { useEffect, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { AppBar, Avatar, Box, Button, Container, Divider, Grid, Popover } from "@material-ui/core";
import { Apps as AppsIcon, SettingsOutlined, BarChart, Assistant } from "@material-ui/icons";
import { ReactComponent as LogoIconSVG } from "@app/assets/allgo_oem_header_icon.svg";
import { ReactComponent as DevLogoTextSVG } from "@app/assets/allgo_dev_header_text.svg";
import { ReactComponent as OemLogoTextSVG } from "@app/assets/for-automaker.svg";
import { ReactComponent as TesterLogoTextSVG } from "@app/assets/allgo_tester_header_text.svg";
import { Link, NavLink } from "@app/components/link";
import { Notification } from "@app/components/notification";
import { logout } from "@app/redux/actions/auth/auth";
import { RootState } from "@app/redux/store/root";
import { retriveNotifications } from "@app/redux/actions/notifications";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AssessmentIcon from "@material-ui/icons/Assessment";
import { routePortalMap } from "@app/App";
import { AuthModel } from "@app/redux/models";
import { resetOemAnalyticsFilters, resetAll } from "@app/redux/actions/oem_analytics";
import TokenService from "@app/redux/services/token";
import useFeatureToggle from "@app/hooks/use-feature-toggle/useFeatureToggle";
import { Feature } from "@app/enums/Feature";
import { shouldShowEmail } from "@app/utils/hashOrMaskPi";
import { ReactComponent as UserLogo } from "@app/assets/user-white.svg";

export const rolePortalNameMap: any = {
    oem: {
        name: "OEM Portal",
        href: "/oem/apps",
    },
    dev: {
        name: "Developer Portal",
        href: "/developer/apps",
    },
    tester: {
        name: "Tester Portal",
        href: "/tester/apps",
    },
    admin: {
        name: "Admin Portal",
        href: "/admin",
    },
};

type StyleProps = {
    text: string;
    background: string;
    avatarBg: string;
};

const useStyles = makeStyles((theme: Theme) => ({
    toolbar: {
        fontSize: "12px",
    },
    alignEnd: {
        textAlign: "end",
    },
    appBar: (props: StyleProps) => ({
        backgroundColor: props.background,
        position: "sticky",
        top: 0,
    }),
    anchor: (props: StyleProps) => ({
        color: props.text,
        display: "inline-flex",
        alignItems: "center",
        padding: theme.spacing(2.125, 0),
        borderBottom: "4px solid transparent",
        "&.active": {
            borderBottomColor: "#ff9800",
        },
        "&:hover": {
            textDecoration: "none",
        },
    }),
    avatar: {
        padding: theme.spacing(1.5, 1),
    },
    button: {
        padding: "4px 10px",
        "&:hover": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    small: (props: StyleProps) => ({
        width: theme.spacing(4),
        height: theme.spacing(4),
        backgroundColor: props.avatarBg,
    }),
    largeAvatar: {
        width: theme.spacing(7),
        height: theme.spacing(7),
        backgroundColor: "#616161",
        margin: "0 auto 10px auto",
        textTransform: "uppercase",
    },
    profile: {
        color: "black",
        display: "block",
        "&:hover": {
            color: "black",
        },
        "& .MuiListItem-root": {
            paddingLeft: "16px",
        },
    },
    popover: {
        left: "1140px",
        marginLeft: "-24px",
    },
    userInfo: {
        textAlign: "center",
        padding: "20px 16px",
    },
    signOut: {
        margin: "15px",
        backgroundColor: "white",
        color: "black",
        fontSize: "10px",
        fontWeight: "normal",
        boxShadow:
            "0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)",
        "&:hover": {
            backgroundColor: "white",
        },
    },
    signOutHidePiCase: {
        marginTop: "2px",
        marginBottom: "2px",
        backgroundColor: "white",
        color: "black",
        fontSize: "10px",
        fontWeight: "normal",
        width: "100%",
        boxShadow: "0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0",
        "&:hover": {
            backgroundColor: "3 3 3 3 ",
            boxShadow: "0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0",
        },
        border: 0,
        paddingLeft: "0px",
        paddingRight: "0px",
    },
    profileBox: {
        width: "230px",
    },
    email: {
        fontSize: "12px",
        fontWeight: 300,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    fullname: {
        fontSize: "14px",
        paddingBottom: "5px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    // notificationBell: {
    //     cursor:"pointer",
    //     borderBottom: '4px solid transparent',
    //     '&.hover': {
    //         borderBottomColor: '#ff9800'
    //     },
    // },
    notificationBell: (props: StyleProps) => ({
        color: props.text,

        borderBottom: "4px solid transparent",
        "&.active": {
            borderBottomColor: "#ff9800",
        },
        "&:hover": {
            textDecoration: "none",
        },
    }),
}));

const HeaderLinks = memo((props: any) => {
    const { styles, role = null } = props;
    const dispatch = useDispatch();
    const authDetails: AuthModel = useSelector((state: RootState) => state.authDetails);
    const [showNotification, setShowNotification] = useState(false);
    const [filter, setFilter] = useState({
        read: "all",
    });
    const fetchNotifications = async () => {
        console.log("fetch notification");
        try {
            await dispatch(retriveNotifications(filter));
            //set notification
        } catch (error) {
            console.log(error);
        } finally {
            console.log("fetching");
        }
    };

    useEffect(() => {
        console.log("use effect");
        fetchNotifications();
    }, [filter]);

    if (role === "tester") {
        return (
            <>
                <Grid item xs={12} md={4}></Grid>
                <Grid item xs={12} md={3}>
                    <NavLink
                        className={styles.anchor}
                        activeClassName="active"
                        to="/tester/apps"
                        onClick={() => window.scroll(0, 0)}
                    >
                        <AppsIcon test-data-id="apps-icon" fontSize="small" /> &nbsp; MY APPS
                    </NavLink>
                </Grid>
            </>
        );
    }

    if (role === "dev") {
        const handleNotificationClick = async () => {
            setShowNotification(!showNotification);
        };

        return (
            <>
                <Grid item xs={10} md={1}></Grid>
                <Grid item xs={12} md={3}>
                    <NavLink
                        className={styles.anchor}
                        activeClassName="active"
                        to="/developer/apps"
                        onClick={() => window.scroll(0, 0)}
                    >
                        <AppsIcon test-data-id="apps-icon" fontSize="small" /> &nbsp; MY APPS
                    </NavLink>
                </Grid>
                <Grid item xs={12} md={3}>
                    <NavLink
                        className={styles.anchor}
                        activeClassName="active"
                        to="/developer/analytics"
                        onClick={() => window.scroll(0, 0)}
                    >
                        <AssessmentIcon test-data-id="apps-icon" fontSize="small" /> &nbsp;
                        ANALYTICS
                    </NavLink>
                </Grid>

                <Grid item xs={8} md={2} onClick={handleNotificationClick}>
                    <Notification
                        setFilter={setFilter}
                        fetchMethod={fetchNotifications}
                        showNotificationModal={showNotification}
                    />
                </Grid>
            </>
        );
    }

    const onAnalyticsTabClick = async () => {
        sessionStorage.setItem("oemAnalyticsTabId", "0");
        window.scroll(0, 0);
        dispatch(resetAll());
        await dispatch(resetOemAnalyticsFilters());
    };

    if (role === "oem") {
        const isAiChatbotEnabled = useFeatureToggle(Feature.AI_CHATBOT, false);
        const mdValue = isAiChatbotEnabled ? 2 : 3;

        return (
            <>
                <Grid item xs={12} md={mdValue}>
                    <NavLink
                        className={styles.anchor}
                        activeClassName="active"
                        to="/oem/apps"
                        onClick={() => window.scroll(0, 0)}
                    >
                        <AppsIcon test-data-id="apps-icon" fontSize="small" /> &nbsp; APPS
                    </NavLink>
                </Grid>
                <Grid item xs={12} md={mdValue}>
                    <NavLink
                        exact
                        className={styles.anchor}
                        activeClassName="active"
                        to="/vehicles"
                        onClick={() => window.scroll(0, 0)}
                    >
                        <DriveEtaIcon test-data-id="drive-eta-icon" fontSize="small" /> &nbsp;
                        VEHICLES
                    </NavLink>
                </Grid>
                <Grid item xs={12} md={mdValue}>
                    <NavLink
                        exact
                        className={styles.anchor}
                        activeClassName="active"
                        to="/oem/analytics"
                        onClick={onAnalyticsTabClick}
                    >
                        <BarChart fontSize="small" /> &nbsp; ANALYTICS
                    </NavLink>
                </Grid>
                {isAiChatbotEnabled && (
                    <Grid item xs={12} md={mdValue}>
                        <NavLink
                            exact
                            className={styles.anchor}
                            activeClassName="active"
                            to="/oem/ai"
                        >
                            <Assistant fontSize="small" /> &nbsp; AI CHAT
                        </NavLink>
                    </Grid>
                )}
            </>
        );
    }

    return null;
});

/**
 * This is used for profile dropdown where list of portals are displayed.
 * Get all roles of the user logged in and based on the current role, display all
 * other portals using rolePortalNameMap
 */
const AuthenticatedHeader = memo((props: any) => {
    const { styles, user, role } = props;

    const history = useHistory();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const dispatch: ThunkDispatch<RootState, void, Action> = useDispatch();
    const handleSignOut = async () => {
        await dispatch(logout());
        history.push("/");
    };

    const open = !!anchorEl;
    const id = open ? "simple-popover" : undefined;

    const showPi = shouldShowEmail(role);

    return (
        <>
            <Grid item xs={12} md={7}>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    className={styles.alignEnd}
                >
                    <HeaderLinks role={role} styles={styles} />
                    <Grid item xs={12} md={2}>
                        <Button
                            test-data-id="username-initials-button"
                            className={styles.avatar}
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={handleClick}
                        >
                            <Avatar test-data-id="username-initials" className={styles.small}>
                                {showPi ? user?.username?.charAt(0) : <UserLogo />}
                            </Avatar>
                        </Button>
                        <Popover
                            test-data-id="profile-dropdown"
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            className={styles.popover}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "center",
                            }}
                        >
                            <Box>
                                {showPi && (
                                    <Box className={styles.userInfo}>
                                        <Avatar
                                            test-data-id="username-initials-dropdown"
                                            className={styles.largeAvatar}
                                        >
                                            {showPi ? (
                                                user?.username?.charAt(0)
                                            ) : (
                                                <UserLogo />
                                            )}
                                        </Avatar>
                                        <Box
                                            test-data-id="first-last-name"
                                            className={styles.fullname}
                                        >
                                            {`${user?.firstname} ${user?.lastname}`.trim()}
                                        </Box>
                                        {showPi && (
                                            <Box test-data-id="username" className={styles.email}>
                                                {user?.username}
                                            </Box>
                                        )}
                                    </Box>
                                )}
                                {showPi && <Divider test-data-id="divider" variant="middle" />}
                                <Box className={styles.profileActions}>
                                    <NavLink exact onClick={handleClose} to="/profile">
                                        <Button
                                            test-data-id="sign-out-button"
                                            variant="contained"
                                            size="small"
                                            className={showPi ? styles.signOut : styles.signOutHidePiCase}
                                            startIcon={<SettingsOutlined />}
                                        >
                                            SETTINGS
                                        </Button>
                                    </NavLink>
                                    <Button
                                        test-data-id="sign-out-button"
                                        variant="contained"
                                        size="small"
                                        className={showPi ? styles.signOut : styles.signOutHidePiCase}
                                        onClick={handleSignOut}
                                        startIcon={<ExitToAppIcon />}
                                    >
                                        SIGN OUT
                                    </Button>
                                </Box>
                            </Box>
                        </Popover>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
});

const DefaultHeader = memo((props: any) => {
    const { styles } = props;
    return (
        <>
            <Grid item xs={12} md={7}>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    className={styles.alignEnd}
                >
                    <Box height={58}></Box>
                    <Grid item xs={12} md={2}>
                        <Link to="/login">
                            <Button
                                test-data-id="sign-in-button"
                                className={styles.button}
                                variant="contained"
                                size="small"
                                color="secondary"
                            >
                                SIGN IN
                            </Button>
                        </Link>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
});

const HeaderLogo = memo((props: any) => {
    const { role } = props;
    return (
        <>
            <LogoIconSVG test-data-id="dev-portal-icon" width="105" />
            {role === "tester" && <TesterLogoTextSVG test-data-id="oem-portal-icon-text" />}
            {role === "oem" && <OemLogoTextSVG test-data-id="oem-portal-icon-text" />}
            {role === "dev" && <DevLogoTextSVG test-data-id="dev-portal-icon-text" />}
        </>
    );
});

const Header = memo(({ fromRegister = false }: { fromRegister: boolean }) => {
    const history = useHistory();
    const authDetails: AuthModel = useSelector((state: RootState) => state.authDetails);
    const routeName = Object.keys(routePortalMap).filter((key) =>
        history.location.pathname.includes(key)
    )[0];

    let role = routeName && routePortalMap[routeName]();

    // when user does not have access to portal then re-route it based on the role it has
    if (authDetails.user) {
        const userFromToken = TokenService.decodeJWT();
        // If the role on the browser url path is not matching with the role from me API (Case where user has manually typed some other url like /tester/apps but its a dev login)
        // Or If the role on browser url path is not matching with the role decoded from the token (Case where user intercepts the me api call and changes role (from dev to tester for eg))
        if (
            role &&
            (!authDetails.user.roles.includes(role) || !userFromToken.roles.includes(role))
        ) {
            // Route based on the role decoded from token (As that cant be manipulated by intercepting the API response)
            history.push(rolePortalNameMap[userFromToken.roles[0]]?.href);
        }
    }

    // Fetching current role when user try to access invalid url
    role = fromRegister ? role : routePortalMap.profile();

    const roleBasedStyles = {
        text: "white",
        background: "#000",
        avatarBg: "#323232",
    };

    const classes = useStyles(roleBasedStyles);

    return (
        <AppBar className={classes.appBar} position="static" elevation={1}>
            <Container maxWidth="md" disableGutters={true}>
                <Grid
                    className={classes.toolbar}
                    container
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid item xs={12} md={5}>
                        <Link
                            onClick={() => window.scrollTo(0, 0)}
                            to={rolePortalNameMap[role]?.href ?? "/"}
                        >
                            <HeaderLogo role={role} />
                        </Link>
                    </Grid>
                    {authDetails.isLoggedIn ? (
                        <AuthenticatedHeader
                            styles={classes}
                            user={authDetails.user}
                            role={role}
                            roles={authDetails?.user?.roles}
                        />
                    ) : (
                        <DefaultHeader pathname={history.location.pathname} styles={classes} />
                    )}
                </Grid>
            </Container>
        </AppBar>
    );
});

export default Header;
